import React from "react";
import PropTypes from "prop-types";
import { SFStack } from "../../../grid";
import SwitchAction from "../../renderers/switch";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const SwitchActionGroupWrapper = styled(SFStack, {
  shouldForwardProp: (prop) => prop !== "disablePadding",
})(({ disablePadding = false }) => ({
  ...(!disablePadding && { paddingRight: "10px" }),
}));

const SwitchActionGroup = ({ actionDefs = [], disablePadding }) => {
  if (actionDefs.length === 0) {
    // If there are no switch action definitions, return null
    return null;
  }

  return (
    <SwitchActionGroupWrapper
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      disablePadding={disablePadding}
    >
      {actionDefs.map((actionDef) => (
        <SwitchAction key={actionDef.name} actionDef={actionDef} />
      ))}
    </SwitchActionGroupWrapper>
  );
};

export default SwitchActionGroup;

SwitchActionGroup.propTypes = {
  actionDefs: PropTypes.arrayOf(
    PropTypes.shape({
      // The name of the action
      name: PropTypes.string.isRequired,
      // The right label of the switch
      label: PropTypes.string,
      // The function to call when the switch is toggled on/off
      onClick: PropTypes.func,
    })
  ),
  // Whether to disable the right padding of the switch action group
  disablePadding: PropTypes.bool,
};
